import type { GetDiffusionsQueryResponse } from '~/api/gen'
import { http, HttpResponse } from 'msw'
import { annoncesDiffusion, annoncesDiffusionAvecErreurs, annoncesDiffusionOfficeMartin } from '~/msw/mocks/diffusion'
import { officeMartin } from '~/msw/mocks/organisation'

// Le listing dépend de l'office demandé, comme en réel : la hotline qui choisit
// `officeMartin` dans le filtre organisation voit ses annonces, pas celles de l'utilisateur.
export function getDiffusionsHandler() {
  return http.get<
    { officeOid: string },
    never,
    GetDiffusionsQueryResponse
  >('http://localhost:3000/api/v1/diffusions/:officeOid', ({ params }) => {
    return HttpResponse.json(params.officeOid === officeMartin.codeNs ? annoncesDiffusionOfficeMartin : annoncesDiffusion)
  })
}

// Variante « scenario » de l'endpoint : diffusions en erreur.
// Branchée via ?scenario=errors et composée dans ~/msw/scenarios.ts.
export function getDiffusionsErrorsHandler() {
  return http.get<
    { officeOid: string },
    never,
    GetDiffusionsQueryResponse
  >('http://localhost:3000/api/v1/diffusions/:officeOid', () => {
    return HttpResponse.json(annoncesDiffusionAvecErreurs)
  })
}
